import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { AdminPrivateLayout } from '@/widgets/admin-private-layout';
import {
  authGuardRoute,
  termAndConditionGuardRoute,
} from '@/features/authenticate';
import { LoadingScreen } from '@drisk-ai/ui';
import { Chatbot } from '@/features/chat';
import { OrganizationClientGroupSelector } from '@/widgets/organization-client-group-selector';

const skipLayoutRenderPaths = ['/terms-and-conditions'];

const skipGlobalSelectorPaths = [
  '/manage/organisations',
  '/manage/client-groups',
  '/settings',
];

export const Route = createFileRoute('/_private')({
  beforeLoad: ctx => {
    authGuardRoute({ isPrivate: true });
    termAndConditionGuardRoute({
      currentPath: ctx.location.pathname,
    });
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingScreen />,
});

function RouteComponent() {
  const location = useLocation();

  if (skipLayoutRenderPaths.some(p => location.pathname.startsWith(p))) {
    return <Outlet />;
  }

  const shouldRenderGlobalSelector = !skipGlobalSelectorPaths.some(p =>
    location.pathname.startsWith(p),
  );

  return (
    <AdminPrivateLayout>
      <div className="flex flex-col h-full">
        {shouldRenderGlobalSelector ? (
          <div className="flex-shrink-0 min-h-[60px] p-4 border-b border-border px-6">
            <OrganizationClientGroupSelector />
          </div>
        ) : null}
        <Chatbot />
        <div className="flex-1 overflow-auto min-h-0">
          <Outlet />
        </div>
      </div>
    </AdminPrivateLayout>
  );
}
